var freeGiftDrawerRefreshPending = false;
var AUTO_GIFT_LOCKED = '_auto__free_gift_locked';
var diamondVariantRefreshPending = false;
var AUTO_DIAMOND_PROP = '_auto_diamond';

// DEFINE THIS GLOBAL FLAG OUTSIDE of $(document).ready
var $isAddingToCart = false;


$(document).ready(function () {

function upsellAddToCart(items) {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { items: items }, // Send items array as data
        dataType: 'json',
        success: function(itemData) {
            UpdateCartDrawer();
            // Successful AJAX request. You can update your cart UI or show a success message.
            $('.cdk_product_upsell_overlay, .cdk_product_upsell_container').hide();
            $('.cdk_product_upsell_container .cdk_upsell_btn').removeClass('upsell_btn_loading');
            $('html').addClass('js-drawer-open lock-scroll');
            $('#CartDrawer').addClass('drawer--is-open');
        },
        error: function(XMLHttpRequest, textStatus) {
            // Handle errors, for example, show an error message
            console.error('Error adding item to cart:', textStatus);
        }
    });
}
  
// =========================================================================
// REVISED AJAX CART ADDITION FUNCTION
// =========================================================================
function addToCart(formData) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    dataType: 'json',
    success: function(itemData) {
      // 1. Reset the global flag
      $isAddingToCart = false; 
      
      // 2. Reset the main button state
      var $mainButton = $('#btnAddtoCart');
      $mainButton.prop('disabled', false); 
      var defaultText = $mainButton.find('[data-add-to-cart-text]').data('default-text') || 'הוספה לסל הקניות';
      $mainButton.find('[data-add-to-cart-text]').text(defaultText); 
      
      // 3. Reset the sticky button state
      $('.btn_sticky_act').removeClass('disabled').text('הוספה לסל הקניות');
      
      // 4. Open and Update Cart Drawer
      $('html').addClass('js-drawer-open lock-scroll');
      $('#CartDrawer').addClass('drawer--is-open');
      UpdateCartDrawer(); // <-- Calls the revised update function
      
    },
    error: function(XMLHttpRequest, textStatus) {
      // Handle error (e.g., variant out of stock)
      // 1. Reset the global flag
      $isAddingToCart = false; 
      
      // 2. Reset the main button state
      var $mainButton = $('#btnAddtoCart');
      $mainButton.prop('disabled', false); 
      var defaultText = $mainButton.find('[data-add-to-cart-text]').data('default-text') || 'הוספה לסל הקניות';
      $mainButton.find('[data-add-to-cart-text]').text(defaultText); 
      
      // 3. Reset the sticky button state
      $('.btn_sticky_act').removeClass('disabled').text('הוספה לסל הקניות');

      console.error('Error adding item to cart:', textStatus);
      
      // Optionally show a notification of the error
    }
  });
}
  
  function updateCartWithItems(cartData) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js', // Shopify's cart update endpoint
      data: {
        updates: cartData,
      },
      dataType: 'json',
      success: function (cart) {
        //console.log('Cart updated successfully:', cart);
        UpdateCartDrawer();
        // Do something after the cart is updated, like refreshing the cart view.
      },
      error: function (xhr, textStatus, errorThrown) {
        //console.error('Error updating cart:', errorThrown);
        // Handle the error, if any.
      },
    });
  }  

function UpdateCartDrawer(){ 
  $.ajax({
    url: '/', // Fetch the full page HTML
    type: 'GET',
    dataType: 'html',
    success: function(data) {
      // 1. Safely parse the fetched HTML data
      var $parsedHTML = $('<div>').html(data);
      
      // 2. Find the new content for the cart drawer form (inner HTML)
      var $newDrawerContent = $parsedHTML.find('#CartDrawerForm').html();
      
      // 3. Update the cart item count
      updateCartItemCount(); 
      
      // 4. Update the content of the *current* #CartDrawerForm
      if ($newDrawerContent) {
        $('#CartDrawerForm').html($newDrawerContent);
        
        // 5. CRITICAL: Re-initialize Streamline theme scripts (initGlobals)
        // This is necessary to bind events to the newly loaded content
        if (typeof theme !== 'undefined' && typeof theme.initGlobals === 'function') {
            theme.initGlobals(); 
            console.log("theme.initGlobals() called to rebind cart events.");
        }
      } else {
        console.error("Failed to find #CartDrawerForm content in fetched HTML.");
      }
      
      // 6. Update the Cart Page Form (if on the cart page)
      var $newCartPageContent = $parsedHTML.find('#CartPageForm').html();
      if ($newCartPageContent) {
        $('#CartPageForm').html($newCartPageContent);
      }
    },
    error: function(xhr, status, error) {
        console.error("Error fetching page data to update cart drawer:", status, error);
    }
  });
}

function getSubtotalExcludingAutoGift(cartData, giftVariantId) {
  var total = 0;

  cartData.items.forEach(function (item) {
    var isAutoGift =
      item.variant_id === giftVariantId &&
      item.properties &&
      item.properties._free_gift === 'true';

    if (!isAutoGift) {
      total += item.final_line_price;
    }
  });

  return total;
}

function getSubtotalExcludingAllGifts(cartData, giftVariantId) {
  var total = 0;

  cartData.items.forEach(function (item) {
    var isAnyGift = item.variant_id === giftVariantId;
    if (!isAnyGift) {
      total += item.final_line_price;
    }
  });

  return total;
}

function hasAutoGift(cartData, giftVariantId) {
  return cartData.items.some(function (item) {
    return (
      item.variant_id === giftVariantId &&
      item.properties &&
      item.properties._free_gift === 'true'
    );
  });
}

function hasManualGift(cartData, giftVariantId) {
  return cartData.items.some(function (item) {
    return (
      item.variant_id === giftVariantId &&
      (!item.properties || !item.properties._free_gift)
    );
  });
}

function handleFreeGift(cartData) {
  var $bar = $('.free-gift-wrapper');
  if (!$bar.length || !cartData) return;

  var giftVariantId = Number($bar.data('gift-variant-id'));
  var threshold = Number($bar.data('gift-threshold'));
  if (!giftVariantId || !threshold) return;

  var qualifyingTotal = getSubtotalExcludingAutoGift(cartData, giftVariantId);

  var autoGiftExists = hasAutoGift(cartData, giftVariantId);
  var manualGiftExists = hasManualGift(cartData, giftVariantId);

  var cartLocked =
    cartData.attributes &&
    cartData.attributes._auto__free_gift_locked === 'true';

  // =====================================================
  // 1️⃣ MANUAL REMOVAL WHILE STILL QUALIFYING → UNLOCK
  // =====================================================
  if (
    cartLocked &&
    !autoGiftExists &&
    qualifyingTotal >= threshold &&
    !freeGiftDrawerRefreshPending
  ) {
    freeGiftDrawerRefreshPending = true;

    $.post('/cart/update.js', {
      attributes: { _auto__free_gift_locked: '' }
    }).always(function () {
      freeGiftDrawerRefreshPending = false;
    });

    return;
  }

  // =====================================================
  // 2️⃣ ADD AUTO FREE GIFT (ONCE)
  // =====================================================
  if (
    qualifyingTotal >= threshold &&
    !autoGiftExists &&
    !cartLocked &&
    !freeGiftDrawerRefreshPending
  ) {
    freeGiftDrawerRefreshPending = true;
    $('.cdk_data_main_cart').addClass('loading');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        items: [{
          id: giftVariantId,
          quantity: 1,
          properties: { _free_gift: 'true' }
        }],
        attributes: {
          _auto__free_gift_locked: 'true'
        }
      }
    }).done(function () {
      setTimeout(function () {
        UpdateCartDrawer();
        freeGiftDrawerRefreshPending = false;
      }, 300);
    });

    return;
  }

  // =====================================================
  // 3️⃣ REMOVE AUTO FREE GIFT (ONLY WHEN INVALID)
  // =====================================================
  if (
    qualifyingTotal < threshold &&
    autoGiftExists &&
    !manualGiftExists &&
    !freeGiftDrawerRefreshPending
  ) {
    freeGiftDrawerRefreshPending = true;
    $('.cdk_data_main_cart').addClass('loading');

    var autoGiftItem = cartData.items.find(function (item) {
      return (
        item.variant_id === giftVariantId &&
        item.properties &&
        item.properties._free_gift === 'true'
      );
    });

    if (!autoGiftItem) {
      freeGiftDrawerRefreshPending = false;
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: autoGiftItem.key,
        quantity: 0
      }
    }).done(function () {
      $.post('/cart/update.js', {
        attributes: { _auto__free_gift_locked: '' }
      }).always(function () {
        setTimeout(function () {
          UpdateCartDrawer();
          freeGiftDrawerRefreshPending = false;
        }, 300);
      });
    });
  }
}

var DIAMOND_COLORS = ['whitediamond', 'golddiamond'];

function cartHasDiamondColor(cartData) {
  if (!cartData || !cartData.items) return false;

  return cartData.items.some(function (item) {
    if (!item.options_with_values) return false;

    return item.options_with_values.some(function (opt) {
      var optionName = String(opt.name || '').toLowerCase();
      var optionValue = String(opt.value || '').toLowerCase();

      return (
        optionName === 'color' &&
        DIAMOND_COLORS.includes(optionValue)
      );
    });
  });
}


function hasAutoDiamond(cartData, diamondVariantId) {
  if (!cartData || !cartData.items) return false;

  return cartData.items.some(function (item) {
    return (
      diamondVariantId.includes(Number(item.variant_id)) &&
      item.properties &&
      item.properties[AUTO_DIAMOND_PROP] === 'true'
    );
  });
}

function getAutoDiamondItem(cartData, diamondVariantId) {
  if (!cartData || !cartData.items) return null;

  return cartData.items.find(function (item) {
    return (
      diamondVariantId.includes(Number(item.variant_id)) &&
      item.properties &&
      item.properties[AUTO_DIAMOND_PROP] === 'true'
    );
  }) || null;
}


function handleDiamondVariant(cartData) {
  var $drawer = $('#CartDrawer');
  if (!$drawer.length || !cartData) return;

  // var diamondVariantId = Number($drawer.data('diamond-variant-id'));
  var diamondVariantId = ($drawer.data('diamond-variant-id') || '')
  .toString()
  .split(',')
  .map(function(id) {
    return Number(id.trim());
  })
  .filter(function(id) {
    return !isNaN(id);
  });
  if (!diamondVariantId.length) return;// feature disabled

  var hasDiamondProduct = cartHasDiamondColor(cartData);
  var autoDiamondExists = hasAutoDiamond(cartData, diamondVariantId);

  // ============================
  // ADD DIAMOND VARIANT
  // ============================
  if (
    hasDiamondProduct &&
    !autoDiamondExists &&
    !diamondVariantRefreshPending
  ) {
    diamondVariantRefreshPending = true;
    var itemsToAdd = diamondVariantId.map(function(id) {
      return {
        id: id,
        quantity: 1,
        properties: {
          [AUTO_DIAMOND_PROP]: 'true'
        }
      };
    });
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        items: itemsToAdd
      }
    }).done(function () {
      setTimeout(function () {
        UpdateCartDrawer();
        diamondVariantRefreshPending = false;
      }, 300);
    });

    return;
  }

  // ============================
  // REMOVE DIAMOND VARIANT
  // ============================
  if (
    !hasDiamondProduct &&
    autoDiamondExists &&
    !diamondVariantRefreshPending
  ) {
    diamondVariantRefreshPending = true;

    var diamondItem = getAutoDiamondItem(cartData, diamondVariantId);
    if (!diamondItem) {
      diamondVariantRefreshPending = false;
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: diamondItem.key,
        quantity: 0
      }
    }).done(function () {
      setTimeout(function () {
        UpdateCartDrawer();
        diamondVariantRefreshPending = false;
      }, 300);
    });
  }
}

function updateCartItemCount() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cartData) {
      handleFreeGift(cartData);
      handleDiamondVariant(cartData);
      // Extract the item count from the cart data
      var cartTotPrice = cartData.total_price;
      //console.log('cartData::'+cartTotPrice);
      var itemCount = cartData.item_count;
      if(itemCount == 0){
        $('#CartDrawer').addClass('is-empty');
      }else{
        $('#CartDrawer').removeClass('is-empty');
      }
      if (cartTotPrice >= 50000){
        
      }
      else if (cartTotPrice >= 75000){
        
      }
      else if (cartTotPrice >= 100000){
        
      }
 
      // Update the cart item count on the website
      $('.cart-link__bubble-num').text(itemCount);
    },
    error: function(XMLHttpRequest, textStatus, errorThrown) {
      // Handle errors, show a specific error message if needed
      //console.error('Error fetching cart data:', textStatus, errorThrown);
    }
  });
}  
  
  // Quantity plus
 
  $(document).on('click', '.cdk_cart__item .quantity__plus', function (adev) {
    adev.stopPropagation();
    var updatedCartData = {};
    
     var qtySelector = $(this).parents('.main-qty-selector').find('input');
     var thisGroupId = qtySelector.attr('data-groupid');
    //console.log('thisGroupId::'+thisGroupId);
    console.log('qtySelector::'+qtySelector);
    // Get the current quantity value
    var qtyUnit = parseInt(qtySelector.val());
    //console.log('qtyUnit::'+qtyUnit);
     // Increment the quantity value
    var newQuantity = qtyUnit + 1;
     console.log('newQuantity::'+newQuantity);
    // Update the input field with the new quantity
    $(qtySelector).val(newQuantity);
 
    $('.cdk_data_main_cart').addClass('loading');

        // Loop through each cart item and build the updatedCartData object
    $('.cdk_cart__item').each(function () {
      var eachGroupId = $(this).find('.main-qty-selector').find('input.js-qty__num').attr('data-groupid');
      if (eachGroupId == thisGroupId) {
        var thisVarId = $(this).find('.main-qty-selector').find('input.js-qty__num').attr('data-id');
        
        updatedCartData[thisVarId] = newQuantity;
      }
    }); 
     updateCartWithItems(updatedCartData); 
  })

    // Quantity minus

    $(document).on('click', '.cdk_cart__item .quantity__minus', function (reev) {
    reev.stopPropagation();
    var updatedCartData = {};
    
     var qtySelector = $(this).parents('.main-qty-selector').find('input');
     var thisGroupId = qtySelector.attr('data-groupid');
    //console.log('thisGroupId::'+thisGroupId);
      console.log('qtySelector::'+qtySelector);
    // Get the current quantity value
    var qtyUnit = parseInt(qtySelector.val());
    //console.log('qtyUnit::'+qtyUnit);
     // Increment the quantity value
      if(qtyUnit > 0){
        var newQuantity = qtyUnit - 1;    
      }else{
        var newQuantity = qtyUnit;
      }
    
     console.log('newQuantity::'+newQuantity);
    // Update the input field with the new quantity
    $(qtySelector).val(newQuantity);
 
    $('.cdk_data_main_cart').addClass('loading');

        // Loop through each cart item and build the updatedCartData object
    $('.cdk_cart__item').each(function () {
      var eachGroupId = $(this).find('.main-qty-selector').find('input.js-qty__num').attr('data-groupid');
      if (eachGroupId == thisGroupId) {
        var thisVarId = $(this).find('.main-qty-selector').find('input.js-qty__num').attr('data-id');
        
        updatedCartData[thisVarId] = newQuantity;
      }
    }); 
     updateCartWithItems(updatedCartData); 
  })

 

// Consolidated handler for BOTH the form submit button AND the sticky button
$('#btnAddtoCart, .btn_sticky_act').off('click').on('click', function(event) {
  event.preventDefault(); 
  
  // Check the global flag to prevent a second execution
  if ($isAddingToCart) {
    console.warn('Skipping submission: Already running.');
    return;
  }
  
  $isAddingToCart = true;
  
  var $button = $(this);
  var $form = $('.product-single__form'); // Always target the main form
  
  // --- UI Update: Disable and set loading text on BOTH buttons ---
  var loadingText = 'טוען...';
  
  // Disable the form button
  $('#btnAddtoCart').prop('disabled', true);
  $('#btnAddtoCart').find('[data-add-to-cart-text]').text(loadingText); 
  
  // Disable the sticky button
  $('.btn_sticky_act').addClass('disabled').text(loadingText); 
  // ---------------------------------------------------------------
  
  var formData = $form.serialize();
  console.log('Sending Add to Cart Request...');
  
  addToCart(formData); 
});
 


  $(document).on('click', '[aria-controls="CartDrawer"]', function (ev) {
    ev.preventDefault(); 
    $('html').addClass('js-drawer-open lock-scroll');
    $('#CartDrawer').addClass('drawer--is-open');
  });
  
  $(document).on('click', '.drawer__close-button', function (evs) {
    evs.preventDefault(); 
    $('html').removeClass('js-drawer-open lock-scroll');
    $('#CartDrawer').removeClass('drawer--is-open');
  })

    $('.variant-input-wrap .variant-input label').click(function() { 
      var thisValInp = parseFloat($('input#timestamp').val());
      var thisValInp = thisValInp + 27;
      $('input#timestamp').val(thisValInp); 
    });
 $(document).on('click', '#addTocartBtn_overlay', function () {
    $('.cdk_product_upsell_overlay, .cdk_product_upsell_container').show();
 })
  
  $(document).on('click', '.cdk_product_upsell_container .up_btn_close', function () {
      $('.cdk_product_upsell_overlay, .cdk_product_upsell_container').hide();
      $('.product-single__form #btnAddtoCart').trigger('click');
  })
  
  $(document).on('click', '.cdk_product_upsell_container .cdk_upsell_btn', function () {
    $(this).addClass('upsell_btn_loading');
      var items = []; 
      var variantId1 = $(this).attr('upsell-data-variant');
      var variantTS1 = $(this).attr('upsell-timestamp');
        
      var variantId2 = $(this).attr('product-data-variant');
      var variantTS2 = $(this).attr('product-timestamp');
      
      // Add both variants to the items array with a quantity of 1 each
      items.push({ quantity: 1, id: variantId1, properties: {'timestamp': variantTS1} });
      items.push({ quantity: 1, id: variantId2, properties: {'timestamp': variantTS2} });
      
      // Call addToCart function with items array
      upsellAddToCart(items);
  });
  
})